module.exports = __webpack_public_path__ + "img/long_logo.bf5282d0.png";